export default __webpack_public_path__ + "images/0a2eb736e7c087aa11d938a0bb1fa9ce.png";